export const DEFAULT_CURRENCY = 'usd';
